import root from 'window-or-global';
import {GetAlertProps} from '../types';

export default function(props: GetAlertProps): VoidFunction {
    if (!props) return null;
    const {history, configState} = props || {};
    return () => {
        history.push('settings');
        root.open(configState.boaHomePage);
    };
}
